import {
    type GetUploadTokenForAnnouncementPhotoResponseType,
    type GetUploadTokenForAnnouncementPhotoRequestType
} from "./type";
import {
    request
} from "../request";

const getUploadTokenForAnnouncementPhoto = async (params: GetUploadTokenForAnnouncementPhotoRequestType): Promise<GetUploadTokenForAnnouncementPhotoResponseType> => {
    return await request<GetUploadTokenForAnnouncementPhotoResponseType>("/announcement/getUploadTokenForAnnouncementPhoto", {
        body: JSON.stringify(params),
        method: "POST"
    });
};
export default getUploadTokenForAnnouncementPhoto;
